import { BULLMQ_JOBS } from '../../constant/message-queue.constant';
import { IBulkUploadModuleConfig } from '../../interface/bulkUpload.interface';

/**
 * Bulk Upload Module Configuration
 * Maps each module's bulk upload endpoints and metadata
 *
 * This configuration-driven approach allows the system to:
 * 1. Reuse the same bulk upload components for different modules
 * 2. Centralize endpoint management
 * 3. Easily add new bulk upload features by adding configuration
 */
export const BULK_UPLOAD_CONFIG: Record<BULLMQ_JOBS, IBulkUploadModuleConfig> = {
  [BULLMQ_JOBS.STUDENT_BULK_UPLOAD]: {
    title: 'Student - Bulk Upload',
    downloadUrl: '/student/profile/bulk-upload/template',
    uploadUrl: '/student/profile/bulk-upload',
    templateFileName: 'Student_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.STUDENT_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.CURRICULUM_BULK_UPLOAD]: {
    title: 'Curriculum - Bulk Upload',
    downloadUrl: '/curriculum/bulk-upload/template',
    uploadUrl: '/curriculum/bulk-upload',
    templateFileName: 'Curriculum_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.CURRICULUM_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.ACADEMIC_YEAR_BULK_UPLOAD]: {
    title: 'Academic Year - Bulk Upload',
    downloadUrl: '/academic-year/bulk-upload/template',
    uploadUrl: '/academic-year/bulk-upload',
    templateFileName: 'Academic_Year_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.ACADEMIC_YEAR_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.CURRICULUM_PREFERENCE_BULK_UPLOAD]: {
    title: 'Operational Hour - Bulk Upload',
    downloadUrl: '/curriculum/preferences/bulk-upload/template',
    uploadUrl: '/curriculum/preferences/bulk-upload',
    templateFileName: 'Curriculum_Preference_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.CURRICULUM_PREFERENCE_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.SUBJECT_BULK_UPLOAD]: {
    title: 'Subject - Bulk Upload',
    downloadUrl: '/subject/bulk-upload/template',
    uploadUrl: '/subject/bulk-upload',
    templateFileName: 'Subject_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.SUBJECT_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.GRADE_BULK_UPLOAD]: {
    title: 'Grade - Bulk Upload',
    downloadUrl: '/grade/bulk-upload/template',
    uploadUrl: '/grade/bulk-upload',
    templateFileName: 'Grade_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.GRADE_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.CLASSROOM_BULK_UPLOAD]: {
    title: 'Classroom - Bulk Upload',
    downloadUrl: 'classroom/bulk-upload/template',
    uploadUrl: 'classroom/bulk-upload',
    templateFileName: 'Class_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.CLASSROOM_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.SYLLABUS_BULK_UPLOAD]: {
    title: 'Syllabus - Bulk Upload',
    downloadUrl: '',
    uploadUrl: '',
    templateFileName: 'Syllabus_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.SYLLABUS_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.TEACHER_BULK_UPLOAD]: {
    title: 'Teacher - Bulk Upload',
    downloadUrl: '/teacher/bulk-upload/template',
    uploadUrl: '/teacher/bulk-upload',
    templateFileName: 'Teacher_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.TEACHER_BULK_UPLOAD,
  },
  [BULLMQ_JOBS.GUARDIAN_BULK_UPLOAD]: {
    title: 'Guardian - Bulk Upload',
    downloadUrl: '/guardian/bulk-upload/template',
    uploadUrl: '/guardian/bulk-upload',
    templateFileName: 'Guardian_Bulk_Upload_Template.xlsx',
    jobName: BULLMQ_JOBS.GUARDIAN_BULK_UPLOAD,
  },
};
